export default __webpack_public_path__ + "static/media/glrc-product.kitchen-basics-included.c1c0df1a.png";